import { mapActions } from "vuex"

export default {
    methods: {
        ...mapActions(['createNotification']),
        showDangerConfirmation(title, message, onConfirm, onError) {
            return this.createNotification({
                type: 'dialog',
                persistent: true,
                color: 'danger',
                title,
                message,
                onConfirm,
                onError,
            })
        },
        showDangerNotification(title, message) {
            return this.createNotification({
                type: 'alert',
                persistent: false,
                color: 'danger',
                title,
                message,
            })
        },
        showPrimaryConfirmation(title, message, onConfirm, onError) {
            return this.createNotification({
                type: 'dialog',
                persistent: true,
                color: 'primary',
                title,
                message,
                onConfirm,
                onError,
            })
        },
        showSuccessNotification(title, message) {
            return this.createNotification({
                type: 'alert',
                persistent: false,
                color: 'success',
                title: title || 'Sucesso',
                message: message || 'Registro salvo com sucesso.',
            })
        },
        showWarningConfirmation(title, message, onConfirm, onCancel, onError) {
            return this.createNotification({
                type: 'dialog',
                persistent: true,
                color: 'warning',
                title,
                message,
                onConfirm: onConfirm || null,
                onCancel: onCancel || null,
                onError: onError || null,
            })
        },
        showWarningNotification(title, message) {
            return this.createNotification({
                type: 'alert',
                persistent: false,
                color: 'warning',
                title,
                message,
            })
        },
    },
}